<h3 class="card-header">{{ "FORGOT_PASSWORD" | translate }}</h3>
<div class="card-body">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label>{{ "REGISTER_EMAIL" | translate }}</label>
      <input
        type="text"
        formControlName="email"
        class="form-control field"
        [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
      />
      <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
        <div *ngIf="f.email.errors.required">Email is required</div>
        <div *ngIf="f.email.errors.email">Email is invalid</div>
      </div>
    </div>
    <div class="form-group">
      <p class="error-message" *ngIf="errorMessage">{{ errorMessage }}</p>
      <button [disabled]="loading" class="btn btn-primary field">
        <span
          *ngIf="loading"
          class="spinner-border spinner-border-sm mr-1"
        ></span>
        {{ "DIARY_SUBMIT" | translate }}
      </button>
      <a routerLink="../login" class="btn btn-link">{{
        "REGISTER_CANCEL" | translate
      }}</a>
    </div>
  </form>
</div>
